import React from 'react';
import { useApp } from '../../context/AppContext';
import { useBreakpoint } from '../../hooks/useBreakpoint';
import Sidebar from './Sidebar';
import MobileNav from './MobileNav';
import HomeScreen from '../Home/HomeScreen';
import LibraryScreen from '../Library/LibraryScreen';
import LeadsScreen from '../Leads/LeadsScreen';
import DealRoomScreen from '../DealRoom/DealRoomScreen';
import DemoHubScreen from '../DemoHub/DemoHubScreen';
import AnalyticsScreen from '../Analytics/AnalyticsScreen';
import TrackingScreen from '../Tracking/TrackingScreen';
import BuyerView from '../Client/BuyerView';
import TeamScreen from '../Team/TeamScreen';
import Toast from '../shared/Toast';
import type { Screen } from '../../types';

const SCREEN_MAP: Partial<Record<Screen, React.FC>> = {
  home:      HomeScreen,
  admin:     LibraryScreen,
  leads:     LeadsScreen,
  dealrooms: DealRoomScreen,
  demohub:   DemoHubScreen,
  analytics: AnalyticsScreen,
  tracking:  TrackingScreen,
  client:    BuyerView,
  team:      TeamScreen,
};

export default function AppShell() {
  const { screen } = useApp();
  const { isMobile, isTablet } = useBreakpoint();
  const ScreenComponent = SCREEN_MAP[screen] || LibraryScreen;

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      {!isMobile && <Sidebar forceCollapsed={isTablet} />}
      <div style={{
        flex: 1, display: 'flex', flexDirection: 'column',
        overflow: 'hidden', minWidth: 0, background: 'var(--surface)',
        paddingBottom: isMobile ? '64px' : 0,
      }}>
        <ScreenComponent />
      </div>
      {isMobile && <MobileNav />}
      <Toast />
    </div>
  );
}
